import { render, staticRenderFns } from "./MdnInput.vue?vue&type=template&id=f605d1fa&"
import script from "./MdnInput.vue?vue&type=script&lang=js&"
export * from "./MdnInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports